import { render, staticRenderFns } from "./UserListFilters.vue?vue&type=template&id=5160426b&"
import script from "./UserListFilters.vue?vue&type=script&lang=js&"
export * from "./UserListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports